import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import Cookies from 'universal-cookie';
import classnames from 'classnames/bind';
import { gql, useQuery } from '@apollo/client';
import { localyticsEvent } from '../../../lib/utils';
import { ANALYTICS_EVENTS } from '../../constants';
import styles from './AlertBanner.module.css';

const cx = classnames.bind(styles);

const universalCookies = new Cookies();

export const GET_FEATURES = gql`
  query Features {
    features {
      n
      v
      p
    }
  }
`;

export default function AlertBanner({ featureName }) {
  const { data } = useQuery(GET_FEATURES);
  const feature = data?.features?.find(f => f.n === featureName);
  const variantName = feature?.v;
  const content = feature?.p?.html;
  const version = feature?.p?.version;
  const bannerId = `${featureName}_${variantName}`;

  const wasClosed = useMemo(() => {
    const lastClosedVersion = universalCookies.get(bannerId);
    return !!lastClosedVersion && lastClosedVersion.toString() === version.toString();
  }, [bannerId, version]);

  const [isHidden, setIsHidden] = useState(wasClosed);

  const handleBannerClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.ALERT_BANNER_CLICK, {
      bannerId,
    });
  }, [bannerId]);

  const handleCloseClick = useCallback(() => {
    localyticsEvent(ANALYTICS_EVENTS.ALERT_BANNER_CLOSE, {
      bannerId,
    });

    // Store current version in cookie, never expire, can only be busted with new version
    universalCookies.set(bannerId, version);

    setIsHidden(true);
  }, [bannerId, version]);

  if (isHidden || !content) {
    return <div />;
  }

  return (
    <div
      style={{
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: content,
        }}
        onClick={handleBannerClick}
      />
      <FontAwesomeIcon
        icon={faTimes}
        className={cx('close')}
        onClick={handleCloseClick}
      />
    </div>
  );
}

AlertBanner.propTypes = {
  featureName: PropTypes.string.isRequired,
};
